import React, { useMemo } from 'react';
import EDList from '../../../../../../BaseComponents/List/EDList';
import { EmptyReason } from '../EmptyReason/EmptyReason';
import BusinessDataExpandableListItem from './BusinessDataExpandableListItem';
import EDDivider from '../../../../../../BaseComponents/Divider/EDDivider';
import { IExtendedBusinessDataProps } from '../BusinessDataSet/BusinessDataSet';
import { FLOATING_MENU_CLEARANCE } from '../../../../../../Components/FloatingBottomArea/FloatingMenu';

/**
 * Komponent som visar en lista av expanderbara listelement.
 */
const BusinessDataExpandableList: React.FunctionComponent<
  React.PropsWithChildren<IExtendedBusinessDataProps>
> = props => {
  const listitems = useMemo(
    () =>
      props.sortedData.rows.map((item, i) => {
        return (
          <React.Fragment key={item.id}>
            <BusinessDataExpandableListItem
              item={item}
              columns={props.columns}
              urval={props.urval}
              selectedId={props.selectedId}
              inlineDetail={props.inlineDetail}
              selectDetail={props.selectDetail}
              collection={props.collection}
            />
            {props.sortedData.rows.length > 1 &&
              i !== props.sortedData.rows.length - 1 && <EDDivider />}
          </React.Fragment>
        );
      }),
    [
      props.sortedData.rows,
      props.columns,
      props.urval,
      props.selectedId,
      props.inlineDetail,
      props.selectDetail,
      props.collection,
    ]
  );

  return (
    <EDList>
      {listitems.length > 0 ? (
        <>
          {listitems}
          {props.floatingMenuBottomSpacing && (
            <div style={{ height: FLOATING_MENU_CLEARANCE }} />
          )}
        </>
      ) : (
        <EmptyReason
          urval={props.urval}
          setUrval={props.setUrval}
          collection={props.collection}
          refetch={props.refetch}
          hasData={props.sortedData.rows.length > 0}
          loading={props.loading}
          inCard={props.inCard}
        />
      )}
    </EDList>
  );
};

//export default withStyles(styles)(BusinessDataExpandableList);
export default BusinessDataExpandableList;
